// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"bff_a bib_tr","StrollerBoxWidget__imageCounselling":"bff_b bib_kg"};